import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider, useApp } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import SetPassword from "@/pages/SetPassword";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import PriceList from "@/pages/PriceList";
import Orders from "@/pages/Orders";
import Invoices from "@/pages/Invoices";
import Employees from "@/pages/Employees";
import Settings from "@/pages/Settings";
import Journal from "@/pages/Journal";
import MyDay from "@/pages/MyDay";

function Protected({ children, roles }) {
  const { user } = useApp();
  if (user === undefined) return <div className="min-h-screen bg-slate-50 flex items-center justify-center text-slate-400">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={user.role === "employe" ? "/ma-journee" : "/"} replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useApp();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={user.role === "employe" ? "/ma-journee" : "/"} replace /> : <Login />} />
      <Route path="/definir-mot-de-passe/:token" element={<SetPassword />} />
      <Route path="/" element={<Protected roles={["admin", "superviseur"]}><Dashboard /></Protected>} />
      <Route path="/ma-journee" element={<Protected roles={["admin", "superviseur", "employe"]}><MyDay /></Protected>} />
      <Route path="/clients" element={<Protected roles={["admin", "superviseur"]}><Clients /></Protected>} />
      <Route path="/tarifs" element={<Protected roles={["admin", "superviseur"]}><PriceList /></Protected>} />
      <Route path="/bons" element={<Protected roles={["admin", "superviseur"]}><Orders /></Protected>} />
      <Route path="/factures" element={<Protected roles={["admin", "superviseur"]}><Invoices /></Protected>} />
      <Route path="/employes" element={<Protected roles={["admin"]}><Employees /></Protected>} />
      <Route path="/configuration" element={<Protected roles={["admin"]}><Settings /></Protected>} />
      <Route path="/journal" element={<Protected roles={["admin"]}><Journal /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppProvider>
          <AppRoutes />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
